<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t("stockReconcileList") }}
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
          :loading="loading"
          :headers="headers"
          :items="stockList"
          :search="search"
          hide-default-footer
          class="elevation-1"
          :server-items-length="totalPage"
          :items-per-page="itemsPerPage"
          :page.sync="currentPage"
          :options.sync="options"
          :mobile-breakpoint="0"
      >
        <!-- Progressive -->
        <template v-slot:progress>
          <v-progress-circular
              indeterminate
              color="green"
              :value="50"
          ></v-progress-circular>
        </template>

        <!-- Header -->
        <template v-slot:header.created_by="{ header }">{{ isOperator ? $t(header.text) : '' }}</template>
        <template v-slot:header.product_name="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.qty="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.cost="{ header }">{{ $t(header.text) }}</template>
        <template v-slot:header.description="{ header }">{{ header.text }}</template>
        <template v-slot:header.action="{ header }">{{ $t(header.text) }}</template>

        <!-- Body -->
        <template v-slot:item.created_by="{item}">{{isOperator ?  item.created_by : ''}}</template>
        <template v-slot:item.product_name="{item}">{{item.sku + ': ' + item.product_name}}</template>
        <template v-slot:item.qty="{item}">{{item.qty + item.unit_name}}</template>
        <template v-slot:item.cost="{item}">{{item.cost | formatNumber}} {{getCurrencySymbol(item.currency_code)}}</template>

        <!-- Action -->
        <template v-slot:item.action="{ item }">
          <v-btn color="success" outlined class="table-action-button" text icon :to="{ name: 'beeshop.outside-business.stock-reconcile-detail', params: { stockReconcileDoc: item}}">
            <font-awesome-icon icon="eye"/>
          </v-btn>
        </template>
      </v-data-table>
      <div class="text-center pt-2">
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-col
              v-if="!$vuetify.breakpoint.xsOnly"
              class="d-flex"
              cols="12"
              sm="1"
          >
            {{ $t("total") }} : {{ totalPage }}
          </v-col>
          <v-col
              class="d-flex"
              cols="12"
              sm="1"
              v-if="!$vuetify.breakpoint.xsOnly"
          >
            <v-select
                :label="$t('perPage')"
                v-model="itemsPerPage"
                :items="pageList"
            ></v-select>
          </v-col>

          <v-pagination
              v-model="currentPage"
              :length="pageCount"
              circle
              prev-icon="mdi-menu-left"
              next-icon="mdi-menu-right"
              :total-visible="$vuetify.breakpoint.mobile ? 5 : 10"
          ></v-pagination>
          <v-col
              class="d-flex"
              cols="12"
              sm="1"
              v-if="!$vuetify.breakpoint.xsOnly"
          >

            <v-text-field
                v-model="currentPageComputed"
                :max="pageCount"
                min="1"
                type="number"
                :label="$t('goto')"
            ></v-text-field>
          </v-col>
        </v-card-actions>
      </div>
    </v-card>
  </div>
</template>
<script>
import MainMixin from "../../../mixins/mainMixin";
import ValidatorMixin from "../../../mixins/validatorMixin";
import OptionDataMixin from "../../../mixins/optionDataMixin";
import _ from "lodash";

export default {
  name: "stockList",
  mixins: [MainMixin, ValidatorMixin, OptionDataMixin],
  data() {
    return {
      headers: [
        {
          text: "shopOwner",
          align: "start",
          value: "created_by"
        },
        {
          text: "productName",
          align: "start",
          value: "product_name"
        },
        {text: "qty", value: "qty", sortable:false},
        {text: "cost", value: "cost", sortable:false},
        {text: this.$t("description"), value: "product_description" ,sortable: false},
        {text: "action", value: "action", sortable: false, width: 50}

      ],
    };
  },
  methods: {
    fetchDataTable: _.debounce(function () {
      let vm = this;
      vm.loading = true;
      vm.fetchStockList({
          member_id: this.isOperator ? '' : this.$store.state.userDoc.contact_id,
          eco_business: 'out_side',
          offset: vm.currentPage,
          limit: vm.itemsPerPage,
      })
    }, 350),
    submit() {
      let vm = this;
      vm.dialog = false;
    },
  },
  computed: {},
  watch: {
    search() {
      this.fetchDataTable();
    },
  },
  created() {

  }
};
</script>
